import { StyleSheet, View } from 'react-native'
import { translate } from '../../../i18n'
import { fontFamily } from '../../../theme'
import { palette } from '../../../theme/palette'
import { CardButton } from '../../CardButton/CardButton'
import { Text } from '../../text/text'
import { DS } from '../../../design-system'

interface CallToActionBaseCardProps {
  onPress: () => void
  title: string
  buttonText: string
  horizontalBorderColor: string
  verticalBorderColor: string
}

export const CallToActionBaseCard = ({
  onPress,
  title,
  buttonText,
  horizontalBorderColor,
  verticalBorderColor
}: CallToActionBaseCardProps) => {
  return (
    <View
      style={[
        styles.container,
        {
          borderColor: horizontalBorderColor,
          borderBottomColor: verticalBorderColor,
          borderTopColor: verticalBorderColor
        }
      ]}
    >
      <Text tx={title} style={DS.typography['Heading 4/Regular']} />
      <CardButton name={translate(buttonText)} nameStyle={DS.typography['Body Small/Medium']} onPress={onPress} />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'space-evenly',
    height: 123,
    borderWidth: 8
  },
  title: {
    fontSize: 24,
    fontFamily: fontFamily.FeatureDeckRegular,
    color: palette.smokyBlack
  }
})
